// navigation.enum.ts — home-page navigation query-param keys.
//
// Cross-file contract: a producer sets one of these on the home URL, and the
// home page reads it on first load to restore the matching modal. Keeping the
// keys here (rather than as loose literals in each file) keeps producer and
// consumer from drifting apart.

export enum HomeQueryParam {
  /** Opens the team modal for the given team id (regular state by default). */
  ViewTeam = "viewTeam",
  /** Which team-modal state `viewTeam` restores into — see `TeamModalUrlMode`.
   *  Absent = the regular (view) state. Meaningless without `viewTeam`. */
  TeamModalMode = "mode",
  /** One-shot: opens the All Teams gallery on the landing, then is stripped.
   *  Unlike `viewTeam` it never mirrors open state — it only carries the
   *  chooser's "Existing team" intent across the navigation home. */
  AllTeamsGallery = "allTeams",
}

/** The `mode` param's closed value set — the team modal's URL grammar. */
export enum TeamModalUrlMode {
  /** The regular read state — the default when the param is absent. */
  View = "view",
  Deploy = "deploy",
  /** Editor with update intent; falls back to view without edit permission. */
  Edit = "edit",
  /** Editor with save-a-copy intent. */
  Copy = "copy",
}
